import * as types from "../constants/ActionTypes"

export const setState = new_state => ({
  type: types.SET_STATE,
  new_state
})

export const addAlert = (alert_type, alert_message) => ({
  type: types.ADD_ALERT,
  alert_type,
  alert_message
})

export const login = credentials => ({
  meta: {remote: true},
  type: types.LOGIN,
  credentials
})

export const logout = () => ({
  meta: {remote: true},
  type: types.LOGOUT
})

export const refreshUsers = () => ({
  meta: {remote: true},
  type: types.REFRESH_USERS,
})

export const createUser = user => ({
  meta: {remote: true},
  type: types.CREATE_USER,
  user
})

export const updateUser = (username, user) => ({
  meta: {remote: true},
  type: types.UPDATE_USER,
  username,
  user
})

export const deleteUser = username => ({
  meta: {remote: true},
  type: types.DELETE_USER,
  username
})

export const updatePassword = (username, password_old, password_new, password_confirm) => ({
  // meta: {remote: true},
  type: types.UPDATE_PASSWORD,
  username
})

export const refreshDealers = () => ({
  meta: {remote: true},
  type: types.REFRESH_DEALERS,
})

export const createDealer = dealer => ({
  meta: {remote: true},
  type: types.CREATE_DEALER,
  dealer
})

export const updateDealer = (uuid, dealer) => ({
  meta: {remote: true},
  type: types.UPDATE_DEALER,
  uuid,
  dealer
})

export const deleteDealer = uuid => ({
  meta: {remote: true},
  type: types.DELETE_DEALER,
  uuid
})

export const refreshOrders = (conditions = {}) => ({
  meta: {remote: true},
  type: types.REFRESH_ORDERS,
  conditions
})

export const createOrder = order => ({
  meta: {remote: true},
  type: types.CREATE_ORDER,
  order
})

export const updateOrder = (uuid, order) => ({
  meta: {remote: true},
  type: types.UPDATE_ORDER,
  uuid,
  order
})

export const deleteOrder = uuid => ({
  meta: {remote: true},
  type: types.DELETE_ORDER,
  uuid
})

export const refreshReturns = (conditions = {}) => ({
  meta: {remote: true},
  type: types.REFRESH_RETURNS,
  conditions
})

export const createReturn = productReturn => ({
  meta: {remote: true},
  type: types.CREATE_RETURN,
  productReturn
})

export const updateReturn = (uuid, productReturn) => ({
  meta: {remote: true},
  type: types.UPDATE_RETURN,
  uuid,
  productReturn
})

export const deleteReturn = uuid => ({
  meta: {remote: true},
  type: types.DELETE_RETURN,
  uuid
})

export const refreshExpenses = (conditions = {}) => ({
  meta: {remote: true},
  type: types.REFRESH_EXPENSES,
  conditions
})

export const createExpense = expense => ({
  meta: {remote: true},
  type: types.CREATE_EXPENSE,
  expense
})

export const updateExpense = (uuid, expense) => ({
  meta: {remote: true},
  type: types.UPDATE_EXPENSE,
  uuid,
  expense
})

export const deleteExpense = uuid => ({
  meta: {remote: true},
  type: types.DELETE_EXPENSE,
  uuid
})



// WEBPACK FOOTER //
// ./src/actions/index.js